(function () {
  // ---- EDIT THESE ----
  var MIN_CART_CONFIG = {
    KW: { min: 0, decimals: 2,  message: "الحد الأدنى للطلب هو 7 د.ك. الرجاء إضافة المزيد من المنتجات." },
    DEFAULT: { min: 7, decimals: 2, message: 'Minimum order value not reached <b class="money">7 KWD</b>. Please add more items.' }
  };
  function onSuccess(cart, total) {
    window.location.onclick = "TRIGGER_QUICK_CHECKOUT()";
  }
  // --------------------
  function getMarket() {
    var c = (window.Shopify && window.Shopify.country) ||
      document.documentElement.getAttribute("data-country") || "DEFAULT";
    return MIN_CART_CONFIG[c] || MIN_CART_CONFIG.DEFAULT;
  }

  window.quick_getMarket = getMarket

  function showPopup(msg) {
    var existing = document.getElementById("min-cart-popup");
    if (existing) existing.remove();
    var overlay = document.createElement("div");
    overlay.id = "min-cart-popup";
    overlay.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:99999;";
    var box = document.createElement("div");
    box.style.cssText = "background:#fff;max-width:360px;width:90%;padding:24px;border-radius:12px;text-align:center;font-family:inherit;box-shadow:0 10px 40px rgba(0,0,0,.2);";
    box.innerHTML =
      '<p style="margin:0 0 16px;font-size:15px;line-height:1.5;">' + msg + '</p>' +
      '<button type="button" style="background:#111;color:#fff;border:0;padding:10px 20px;border-radius:8px;cursor:pointer;">OK</button>';
    box.querySelector("button").addEventListener("click", function () { overlay.remove(); });
    overlay.addEventListener("click", function (e) { if (e.target === overlay) overlay.remove(); });
    overlay.appendChild(box);
    document.body.appendChild(overlay);
  }
  /**
   * Check cart total against the market minimum.
   * @param {Function} [cb] - method to run when minimum is met.
   * @param {Object}   [opts]
   * @param {number}   [opts.minOverride]
   * @param {string}   [opts.messageOverride]
   */
  window.checkMinimumCartValue = function (cb, opts) {

    return true
    opts = opts || {};
    var market = getMarket();
    var minimum = typeof opts.minOverride === "number" ? opts.minOverride : market.min;
    var message = opts.messageOverride || market.message;
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) {
        if (!res.ok) throw new Error("cart.js request failed");
        return res.json();
      })
      .then(function (cart) {
        var total = cart.total_price / Math.pow(10, market.decimals);
        if (total >= minimum) {
          (cb || onSuccess)(cart, total);
          return true;
        }
        showPopup(message);
        return false;
      })
      .catch(function (err) {
        console.error("[min-cart-check]", err);
        showPopup(message);
        return false;
      });
  };
//   document.addEventListener("click", function (e) {
//     var btn = e.target.closest("[name='checkout'], #checkout-button, .checkout-button");
//     if (!btn) return;
//     e.preventDefault();
//     window.checkMinimumCartValue();
//   }, true);
})();